// extracted by mini-css-extract-plugin
export default {"uploadTimelinesContainer":"styles_uploadTimelinesContainer__RazIF","actionBtn":"styles_actionBtn__NzIgH","uploadIcon":"styles_uploadIcon__qgflM"};